import {request} from '@/util/request'
import {OSS_BUCKETNAME} from '@/util/variable'
/**
 * 获取cos授权
 */
export const getCosAuthorization = () => {
  return request({
    url: '/webApi/app/moving/vehicle/cos-authorization/getAuthorization',
    method: 'post',
    data:{
       "bucketName": OSS_BUCKETNAME,
        "prefix": "images",
        "type": "getObject"
    }
  })
}

export const putCosAuthorization = () => {
  return request({
    url: '/webApi/app/moving/vehicle/cos-authorization/getAuthorization',
    method: 'post',
    data:{
        "bucketName": OSS_BUCKETNAME,
        "prefix": "images",
        "type": "putObject"
    }
  })
}


// ==================== 城市数据 ====================

// 查询城市列表
// 入参：无
export const getCityList = (params) => {
  return request({
    url: '/webApi/pc/city/list',
    method: 'get',
    params
  })
}
// 查询三级区域列表
// 入参：无
export const getAreaThreeList = (params) => {
  return request({
    url: '/webApi/pc/city/get-area-three',
    method: 'get',
    params
  })
}

// ==================== 服务大项配置 ====================

// 服务大项配置 - 查询数据
// 入参：
//   state - 状态枚举值：ENABLE(0, "启用"), FORBID(1, "禁用")；查询全部不传该参数
export const getServiceList = (data) => {
  return request({
    url: '/webApi/pc/primary/service/list',
    method: 'post',
    data
  })
}

// 服务大项配置 - 新增数据
// 入参：
//   state - 状态枚举值：ENABLE(0, "启用"), FORBID(1, "禁用")
//   imgUrl - 图标URL（OCC图片链接）
export const addService = (data) => {
  return request({
    _showLoading: true,
    url: '/webApi/pc/primary/service/add',
    method: 'post',
    data
  })
}

// 服务大项配置 - 修改数据（包含修改和删除）
// 入参：
//   deleted - 删除操作时传入1
export const updateService = (data) => {
  return request({
    _showLoading: true,
    url: '/webApi/pc/primary/service/update',
    method: 'post',
    data
  })
}


// ==================== 服务类型配置 ====================

// 服务类型配置 - 查询数据
// 入参：
//   state - 状态枚举值：ENABLE(0, "启用"), FORBID(1, "禁用")
//   primaryServiceId - 服务大项id
//   serviceTypeName - 服务类型名字
export const getServiceTypeList = (data) => {
  return request({ 
    url: '/webApi/pc/service/type/list',
    method: 'post',
    data
  })
}

// 服务类型配置 - 更新数据
// 入参：
//   deleted - 删除操作时传入1
export const updateServiceType = (data) => {
  return request({
    _showLoading: true,
    url: '/webApi/pc/service/type/update',
    method: 'post',
    data
  })
}

// 服务类型配置 - 保存数据
// 入参：
//   state - 状态枚举值：ENABLE(0, "启用"), FORBID(1, "禁用")
//   primaryServiceId - 关联的服务大项id
export const addServiceType = (data) => {
  return request({
    _showLoading: true,
    url: '/webApi/pc/service/type/add',
    method: 'post',
    data
  })
}


// ==================== 移动车型号配置 ====================

// 移动车型号配置 - 保存接口
// 入参：
//   state - 状态枚举值：ENABLE(0, "启用"), FORBID(1, "禁用")
//   primaryServiceId - 服务大项id
export const addMovingVehicleType = (data) => {
  return request({
    _showLoading: true,
    url: '/webApi/pc/moving/vehicle/type/add',
    method: 'post',
    data
  })
}

// 移动车型号配置 - 更新接口
// 入参：
//   deleted - 删除操作时传入1
export const updateMovingVehicleType = (data) => {
  return request({
    _showLoading: true,
    url: '/webApi/pc/moving/vehicle/type/update',
    method: 'post',
    data
  })
}

// 移动车型号配置 - 查询接口
// 入参：无
export const getMovingVehicleTypeList = (data) => {
  return request({
    url: '/webApi/pc/moving/vehicle/type/list',
    method: 'post',
    data
  })
}


// ==================== 停靠点配置 ====================

// 停靠点配置 - 保存接口
// 入参：
//   latitude - 纬度（真实经纬度*10的6次方，如80.121606传80121606）
//   longitude - 经度（真实经纬度*10的6次方）
//   serviceRadius - 服务半径，单位米
//   state - 状态枚举值：ENABLE(0, "启用"), FORBID(1, "禁用")
export const addSite = (data) => {
  return request({
    _showLoading: true,
    url: '/webApi/pc/site/add',
    method: 'post',
    data
  })
}

// 停靠点配置 - 更新接口
// 入参：
//   deleted - 删除操作时传入1
export const updateSite = (data) => {
  return request({
    _showLoading: true,
    url: '/webApi/pc/site/update',
    method: 'post',
    data
  })
}


// ==================== 停靠点管理 ====================

// 查询站点停靠的移动车
// 入参：
//   siteId - 站点id
// 返回值：List<MovingVehicleManagementVO>
export const getMovingVehicleListBySiteId = (params) => {
  return request({
    url: '/webApi/pc/moving/vehicle/list-by-siteId',
    method: 'get',
    params
  })
}

// 停靠点配置 - 查询接口
// 入参：
//   state - 状态枚举值：ENABLE(0, "启用"), FORBID(1, "禁用")
export const getSiteList = (data) => {
  return request({
    url: '/webApi/pc/site/list',
    method: 'post',
    data
  })
}


// ==================== 移动车管理 ====================

// 移动车管理 - 保存接口
// 入参：
//   serviceRadius - 服务半径，单位米
//   state - 状态枚举值：ENABLE(0, "启用"), FORBID(1, "禁用")
export const addMovingVehicle = (data) => {
  return request({
    _showLoading: true,
    url: '/webApi/pc/moving/vehicle/add',
    method: 'post',
    data
  })
}

// 移动车管理 - 更新接口
// 入参：
//   deleted - 删除操作时传入1
export const updateMovingVehicle = (data) => {
  return request({
    _showLoading: true,
    url: '/webApi/pc/moving/vehicle/update',
    method: 'post',
    data
  })
}

// 移动车管理 - 查询接口
// 入参：
//   state - 状态枚举值：ENABLE(0, "启用"), FORBID(1, "禁用")
export const getMovingVehicleList = (data) => {
  return request({
    url: '/webApi/pc/moving/vehicle/list',
    method: 'post',
    data
  })
}
 

// 移动车管理 - 订单记录
// 入参：
//   vehicleId - 移动车id
//   pageNum - 页码
//   pageSize - 每页数量
// 返回值：SimpleOrderDTO
export const getVehicleOrderList = (data) => {
  return request({
    url: '/webApi/pc/order/vehicle',
    method: 'post',
    data
  })
}

// 移动车管理 - 查看订单详情
// 入参：
//   orderId - 订单id
// 返回值：OrderDTO
export const getOrderDetail = (params) => {
  return request({
    url: '/webApi/pc/order/detail',
    method: 'get',
    params
  })
}

// 移动车日程表
// 入参：
//   vehicleId - 移动车id
//   technicianId - 技师id
//   beginTime - 开始时间
//   endTime - 结束时间
//   pageNum - 页码
//   pageSize - 每页数量
// 返回值：List<VehicleScheduleVO>
export const getOrderListSchedule = (data) => {
  return request({
    url: '/webApi/pc/order/list-schedule',
    method: 'post',
    data
  })
}


// ==================== 服务项目配置 ====================

// 服务项目配置 - 保存数据
// 入参：
//   primaryServiceId - 移动车所属大类id
//   serviceTypeId - 移动车所属类型id
//   imgUrl - 图标URL
//   detailImgUrl - 详情图标URL
//   SimpleCategoryDTO - 商品分类数据（categoryId: 分类id, categoryName: 分类名字）
//   ServicePriceVO - 价格详情数据（ServiceCallFee: 上门费规则, laborFee: 工时费规则）
//   ServiceCallFeeVO - 上门费（serviceType: 计费类型 1.按公里计费, price: 价格, minPrice: 最低价格, maxPrice: 最高价格）
//   LaborFeeVO - 工时费（fixedPrice: 固定价格, type: 价格类型 1固定价格 10技师等级计费, technician: 技师等级计费）
//   TechnicianVO - 技师等级（level: 技术职级 1初级技师 10等, price: 技师价格, description: 服务简介）
export const addServiceProject = (data) => {
  return request({
    _showLoading: true,
    url: '/webApi/pc/service/add',
    method: 'post',
    data
  })
}

// 服务项目配置 - 更新数据
// 入参：同上
export const updateServiceProject = (data) => {
  return request({
    _showLoading: true,
    url: '/webApi/pc/service/update',
    method: 'post',
    data
  })
}

// 服务项目配置 - 查询数据
// 入参：
//   state - 状态枚举值：ENABLE(0, "启用"), FORBID(1, "禁用")
// 返回值：ServiceMerchantVO, ServicePriceVO, ServiceCallFeeVO, LaborFeeVO, TechnicianGradePriceVO
export const getServiceProjectList = (data) => {
  return request({
    url: '/webApi/pc/service/list',
    method: 'post',
    data
  })
}

// 服务项目营销活动
export const addServiceCampaign = (data) => {
  return request({
    _showLoading: true,
    url: '/webApi/pc/moving/vehicle/service/campaign/management/add',
    method: 'post',
    data
  })
}

export const updateServiceCampaign = (data) => {
  return request({
    _showLoading: true,
    url: '/webApi/pc/moving/vehicle/service/campaign/management/update',
    method: 'post',
    data
  })
}

export const getServiceCampaignList = (data) => {
  return request({
    url: '/webApi/pc/moving/vehicle/service/campaign/management/list',
    method: 'post',
    data
  })
}


// ==================== 商品分类 ====================

// 服务项目配置 - 商品分类数据查询
// 入参：无
// 返回值：List<CategoryNodeDTO>
export const getCategoryList = (data) => {
  return request({
    url: '/webApi/pc/category/list',
    method: 'post',
    data
  })
}




// ==================== 技师人员管理 ====================


// 技师人员管理 - 接单列表
// 入参：
//   technicianId - 技师id
//   pageNum - 页码
//   pageSize - 每页数量
// 返回值：SimpleOrderDTO
export const getTechnicianOrderList = (data) => {
  return request({
    url: '/webApi/pc/order/technician',
    method: 'post',
    data
  })
}


// ==================== 订单管理 ====================

// 上门服务列表 - 查询上门订单列表
// 入参：
//   userId - 用户id
//   userType - 用户类型（RoleTypeEnum）
//   orderSn - 订单号
//   consumerMob - 消费者手机号
//   technicianMob - 技师手机号
//   investorMob - 投资人手机号
//   serviceBeginTime - 服务开始时间
//   serviceEndTime - 服务结束时间
//   createOrderBeginTime - 创建订单开始时间
//   createOrderEndTime - 创建订单结束时间
//   orderStateList - 订单状态列表
//   pageNum - 页码
//   pageSize - 每页数量
export const getOrderListOrder = (data) => {
  return request({
    url: '/webApi/pc/order/list-order',
    method: 'post',
    data
  })
}

// 订单变更数据查询
// 入参：
//   orderId - 订单id
// 返回值：List<OrderChangeDTO>, OrderTimeChangeDTO
export const getOrderListChange = (params) => {
  return request({
    url: '/webApi/pc/order/list-change',
    method: 'get',
    params
  })
}

// 取消订单
// 入参：
//   orderId - 订单id
// 返回值：0表示成功，其他值表示该状态下的订单不允许取消订单
export const cancelOrder = (data) => {
  return request({
    _showLoading: true,
    url: '/webApi/pc/order/cancel',
    method: 'post',
    data
  })
}

// 订单导出（完整版）
// 入参：
//   userId - 用户id
//   userType - 用户类型
//   orderSn - 订单号
//   consumerMob - 消费者手机号
//   technicianMob - 技师手机号
//   investorMob - 投资人手机号
//   serviceBeginTime - 服务开始时间
//   serviceEndTime - 服务结束时间
//   createOrderBeginTime - 创建订单开始时间
//   createOrderEndTime - 创建订单结束时间
//   orderStateList - 订单状态列表
//   pageNum - 页码
//   pageSize - 每页数量
// 返回值：excel数据的下载地址
export const uploadOrderFull = (data) => {
  return request({
    _showLoading: true,
    url: '/webApi/pc/order/upload-order',
    method: 'post',
    data
  })
}


// ==================== 系统配置 ====================

// 系统管理 - 订单取消配置 - 保存接口
// 入参：
//   customerPayTime - 用户支付时间限制（分钟）
//   technicianAcceptOrderTime - 技师接单时间限制（分钟）
export const addOrderCancelConfig = (data) => {
  return request({
    _showLoading: true,
    url: '/webApi/pc/system/configuration/add-order-cancel',
    method: 'post',
    data
  })
}

// 系统管理 - 订单取消配置 - 更新接口
// 入参：
//   id - 配置id
//   customerPayTime - 用户支付时间限制（分钟）
//   technicianAcceptOrderTime - 技师接单时间限制（分钟）
export const updateOrderCancelConfig = (data) => {
  return request({  
    _showLoading: true,
    url: '/webApi/pc/system/configuration/update-order-cancel',
    method: 'post',
    data
  })
}

// 系统管理 - 订单取消配置 - 查询接口
// 入参：无
// 返回值：OrderCancelConfigurationVO
export const getOrderCancelConfig = (params) => {
  return request({
    url: '/webApi/pc/system/configuration/get-order-cancel',
    method: 'get',
    params
  })
}

// 系统管理 - 售后退款规则配置 - 保存接口
// 入参：
//   technicianNotAcceptOrder - 技师未接单退款规则
//   technicianNotDoorToDoor - 技师未上门退款规则
//   autoRefundTime - 自动退款时间（分钟）
export const addRefundConfig = (data) => {
  return request({
    _showLoading: true,
    url: '/webApi/pc/system/configuration/add-refund',
    method: 'post',
    data
  })
}

// 系统管理 - 售后退款规则配置 - 更新接口
// 入参：
//   id - 配置id
//   technicianNotAcceptOrder - 技师未接单退款规则
//   technicianNotDoorToDoor - 技师未上门退款规则
//   autoRefundTime - 自动退款时间（分钟）
export const updateRefundConfig = (data) => {
  return request({  
    _showLoading: true,
    url: '/webApi/pc/system/configuration/update-refund',
    method: 'post',
    data
  })
}

// 系统管理 - 售后退款规则配置 - 查询接口
// 入参：无
// 返回值：OrderRefundConfigurationVO
export const getRefundConfig = (params) => {
  return request({
    url: '/webApi/pc/system/configuration/get-refund',
    method: 'get',
    params
  })
}

// 系统管理 - 售后退款原因配置 - 保存接口
// 入参：
//   cancelOrderReasonMerchantList - 商家取消订单原因列表
//   cancelOrderReasonCustomerList - 用户取消订单原因列表
//   refundOrderReasonMerchantList - 商家退款原因列表
//   refundOrderReasonCustomerList - 用户退款原因列表
//   platformRefundOrderReasonMerchantList - 平台退款原因列表（商家）
//   platformRefundOrderReasonCustomerList - 平台退款原因列表（用户）
export const addCancelAndRefundReason = (data) => {
  return request({
    _showLoading: true,
    url: '/webApi/pc/system/configuration/add-cancel-and-refund-reason',
    method: 'post',
    data
  })
}
// 系统管理 - 售后退款原因配置 - 更新接口
// 入参：
//   id - 配置id
export const updateCancelAndRefundReason = (data) => {
  return request({  
    _showLoading: true,
    url: '/webApi/pc/system/configuration/update-cancel-and-refund-reason',
    method: 'post',
    data
  })
}

// 系统管理 - 售后退款原因配置 - 查询接口
// 入参：无
export const getCancelAndRefundReason = (params) => {
  return request({
    url: '/webApi/pc/system/configuration/get-cancel-and-refund-reason',
    method: 'get',
    params
  })
}

// 系统管理 - 技师拒单规则 - 查询接口
// 入参：无
export const getTechnicianOrderCancel = (params) => {
  return request({
    url: '/webApi/pc/system/configuration/get-technician-order-cancel',
    method: 'get',
    params
  })
}

// 系统管理 - 技师拒单规则 - 保存接口
// 入参：
//   cancelOrderReasonTechnicianList - 技师取消订单原因列表
export const addTechnicianOrderCancel = (data) => {
  return request({
    url: '/webApi/pc/system/configuration/add-technician-order-cancel',
    method: 'post',
    data
  })
}
// 系统管理 - 技师拒单规则 - 更新接口
// 入参：
export const updateTechnicianOrderCancel = (data) => {
  return request({  
    _showLoading: true,
    url: '/webApi/pc/system/configuration/update-technician-order-cancel',
    method: 'post',
    data
  })
}


// ==================== 日志管理 ====================

// 查询订单处理日志
// 入参：
//   orderId - 订单id
// 返回值：List<OrderInfoLogVO>
export const getOrderLogDetail = (params) => {
  return request({
    url: '/webApi/pc/log/get-order-log',
    method: 'get',
    params
  })
}

// 退款日志数据
// 入参：
//   refundId - 退款id
// 返回值：List<OrderInfoLogVO>
export const getRefundLog = (params) => {
  return request({
    url: '/webApi/pc/log/get-refund-log',
    method: 'get',
    params
  })
}


// ==================== 退款管理 ====================

// 根据订单ID查询退款记录
// 入参：
//   orderId - 订单id
// 返回值：List<OrderRefundDTO>
export const getRefundByOrderId = (params) => {
  return request({
    url: '/webApi/pc/refund/get-refund-by-orderId',
    method: 'get',
    params
  })
}

// 查看退款列表
// 入参：
//   userId - 用户id
//   userType - 用户类型
//   orderId - 订单id
//   refundSn - 退款单号
//   refundStateList - 退款状态列表
//   pageNum - 页码
//   pageSize - 每页数量
// 返回值：List<OrderRefundDTO>
export const getRefundListRefund = (data) => {
  return request({
    url: '/webApi/pc/refund/list-refund',
    method: 'post',
    data
  })
}

// 退款详情 - 查看详情
// 入参：
//   refundId - 退款id
// 返回值：OrderServiceDTO, OrderItemDTO
export const getRefundByRefundId = (params) => {
  return request({
    url: '/webApi/pc/refund/get-by-refundId',
    method: 'get',
    params
  })
}

// 退款详情
// 入参：
//   refundId - 退款id
// 返回值：OrderRefundDetailDTO
export const getRefundDetailByRefundId = (params) => {
  return request({
    url: '/webApi/pc/refund/get-refund-detail-by-refundId',
    method: 'get',
    params
  })
}

// 退款导出
// 入参：同退款列表入参
// 返回值：excel数据上传地址
export const uploadRefundFull = (data) => {
  return request({
    _showLoading: true,
    url: '/webApi/pc/refund/upload-refund',
    method: 'post',
    data
  })
}

// 退款处理 - 同意或者拒绝
// 入参：
//   refundId - 退款id
//   dealType - 处理类型（同意/拒绝）
//   auditReason - 审核原因
export const dealRefundFull = (data) => {
  return request({
    _showLoading: true,
    url: '/webApi/pc/refund/deal-refund',
    method: 'post',
    data
  })
}

// 查看退款结果
// 入参：
//   refundId - 退款id
// 返回值：OrderRefundDetailDTO
export const getRefundListDetail = (data) => {
  return request({
    url: '/webApi/pc/refund/list-refund-detail',
    method: 'post',
    data
  })
}

// 退款原因
// 入参：
//   refundId - 退款id
export const refundRetry = (params) => {
  return request({
    url: '/webApi/pc/refund/refund-retry',
    method: 'get',
    params
  })
}

// 退款详情导出
// 入参：
//   refundId - 退款id
// 返回值：excel数据上传地址
export const uploadRefundDetail = (data) => {
  return request({
    _showLoading: true,
    url: '/webApi/pc/refund/upload-refund-detail',
    method: 'post',
    data
  })
}

// ==================== 货车司机审核管理 ====================

//货车司机 注册申请分页列表（待审核-已拒绝）
export const getUserTruckerList = (data) => {
  return request({
    url: '/webApi/pc/user/trucker/registration/list',
    method: 'post',
    data
  })
}
// 货车司机 审核注册申请（通过-拒绝）
// 入参：
//   registrationId - 注册记录ID
//   pass - 是否通过/拒绝 true/false
//   remark - 拒绝原因
//refusedReason 拒绝原因枚举码（pass=false 时选填）	
export const auditUserTruckerRegistration = (data) => {
  return request({
    _showLoading: true,
    url: '/webApi/pc/user/trucker/registration/audit',
    method: 'post',
    data
  })
}
// 正式司机 正式司机分页列表（已通过-停用-封禁）
export const getTruckerDriverList = (data) => {
  return request({
    url: '/webApi/pc/user/trucker/personal/list',
    method: 'post',
    data
  })
}
// 正式司机 正式司机详情
// 入参：
//   userId - 用户id
// 返回值：UserTruckerDTO
export const getTruckerDriverDetail = (userId) => {
  return request({
    url: '/webApi/pc/user/trucker/' + userId,
    method: 'get'
  })
}
// 正式司机 查看注册申请详情
// 入参：
//   registrationId - 注册记录ID
// 返回值：UserTruckerDTO
export const getTruckerRegistrationDetail = (registrationId) => {
  return request({
    url: '/webApi/pc/user/trucker/registration/' + registrationId,
    method: 'get'
  })
}

// -------------公司司机管理---------

// 公司司机 禁用公司司机
// 入参：
//   companyOrgId - 公司组织ID
//   disabled - 是否禁用
export const disableTruckerCompany = (companyOrgId, disabled) => {
  return request({
    url: '/webApi/pc/user/trucker/company/' + companyOrgId + '/disable',
    method: 'put',
    data: {
      disabled
    }
  })
}
// 创建司机公司组织
// 入参：
//   companyName - 公司名称
//   contactName - 公司联系人
//   contactPhone - 公司联系电话
//   cityId - 城市id
//   businessLicenseImgUrlList - 公司营业执照图片列表
export const createTruckerCompany = (data) => {
  return request({
    url: '/webApi/pc/user/trucker/company',
    method: 'post',
    data
  })
}
// 批量为公司添加司机
// 入参：
//   truckers - [{}]司机列表
export const addCompanyTruckers = (companyOrgId, data) => {
  return request({
    _showLoading: true,
    url: '/webApi/pc/user/trucker/company/' + companyOrgId + '/truckers',
    method: 'post',
    data
  })
}
// 为公司创建管理员账号
// 入参：
//   truckers - [{}]司机列表
export const addCompanyAdminTruckers = (companyOrgId, data) => {
  return request({
    _showLoading: true,
    url: '/webApi/pc/user/trucker/company/' + companyOrgId + '/admin',
    method: 'post',
    data
  })
}
// 公司司机分页列表
// 入参：
//   pageNum - 页码
//   pageSize - 每页数量
// 返回值：List<UserTruckerDTO>
export const getTruckerCompanyList = (data) => {
  return request({
    url: '/webApi/pc/user/trucker/company/list',
    method: 'post',
    data
  })
}

// 公司司机分页列表
// 入参：
//   pageNum - 页码
//   pageSize - 每页数量
// 返回值：List<UserTruckerDTO>
export const getTruckerCompanyTruckersList = (data) => {
  return request({
    url: '/webApi/pc/user/trucker/company/truckers/list',
    method: 'post',
    data
  })
}
// 公司司机详情
// 入参：
//   userId - 用户id
// 返回值：UserTruckerDTO
export const getTruckerCompanyTruckersDetail = (userId) => {
  return request({
    url: '/webApi/pc/user/trucker/company/truckers/' + userId,
    method: 'get'
  })
}
// 为公司添加单个司机（免审核直接激活）
// 入参：
//   companyOrgId - 公司组织ID
//   userId - 用户id
// 返回值：UserTruckerDTO
export const addTruckerCompanyTruckers = (data) => {
  return request({
    url: '/webApi/pc/user/trucker/company/truckers/single',
    method: 'post',
    data
  })
}
// 公司司机 更新
// 入参：
//   userId - 用户id
//   data - 更新数据
export const updateTruckerCompanyTruckers = (data) => {
  return request({
    url: '/webApi/pc/user/trucker/company/truckers/update',
    method: 'post',
    data
  })
}
// 审核公司（通过-拒绝，批量更新旗下所有司机）
// 入参：
//   companyOrgId	公司组织ID		true	
// pass	是否通过：true-通过 false-拒绝		true
// remark	拒绝原因（pass=false 时必填）		false	
// refusedReason	拒绝原因枚举码（pass=false 时选填）
export const auditTruckerCompany = (data) => {
  return request({
    _showLoading: true,
    url: '/webApi/pc/user/trucker/company/audit',
    method: 'post',
    data
  })
}
// 公司详情（含旗下所有司机）
// 入参：
//   companyOrgId	公司组织ID		true	
// pass	是否通过：true-通过 false-拒绝		true	
// remark	拒绝原因（pass=false 时必填）		false	
// refusedReason	拒绝原因枚举码（pass=false 时选填）
export const getTruckerCompanyDetail = (companyOrgId) => {
  return request({
    url: '/webApi/pc/user/trucker/company/' + companyOrgId,
    method: 'get'
  })
}

// 分账管理 分账列表
// 入参：
//   pageNum - 页码
//   pageSize - 每页数量
// 返回值：List<OrderSettleDTO>
export const getOrderSettleList = (data) => {
  return request({
    url: '/webApi/pc/order/settle/page',
    method: 'post',
    data
  })
}
// 分账管理 分账详情
// 入参：
//   orderSettleId - 分账id
export const getOrderSettleDetail = ({orderSettleId}) => {
  return request({
    url: '/webApi/pc/order/settle/settle-detail?orderSettleId=' + orderSettleId,
    method: 'get'
  })
}
// 入参：orderSettleIds
export const auditOrderSettle = (data) => {
  return request({
    _showLoading: true,
    url: '/webApi/pc/order/settle/audit',
    method: 'get',
    params: data
  })
}
///----------------公司车辆管理----------------

// 公司车辆分页列表
// 入参：
//   pageNum - 页码
//   pageSize - 每页数量
// 返回值：List<UserTruckerVehicleDTO>
export const getTruckerVehicleList = (data) => {
  return request({
    url: '/webApi/pc/user/trucker/vehicle/list',
    method: 'post',
    data
  })
}
//新增公司车辆
export const addTruckerVehicle = (data) => {
  return request({
    url: '/webApi/pc/user/trucker/vehicle',
    method: 'post',
    data
  })
}
// 删除公司车辆
export const deleteTruckerVehicle = (vehicleId) => {
  return request({
    url: '/webApi/pc/user/trucker/vehicle/' + vehicleId,
    method: 'delete'
  })
}
// 更新公司车辆
// 入参：
//   vehicleId - 车辆id
//   data - 车辆信息
export const updateTruckerVehicle = (data) => {
  return request({
      url: '/webApi/pc/user/trucker/vehicle/' + data.id,
    method: 'put',
    data
  })
}

// 公司车辆详情
// 入参：
//   vehicleId - 车辆id
// 返回值：UserTruckerVehicleDTO
export const getTruckerVehicleDetail = (vehicleId) => {
  return request({
    url: '/webApi/pc/user/trucker/vehicle/' + vehicleId,
    method: 'get'
  })
}
 

// ==================== 车辆维保管理 ====================
//查询车辆配置数据
export const getMovingVehicleRecommendListApi = (data) => {
  return request({
    _showLoading: false,
    url: '/webApi/pc/moving/vehicle/car/recommend/main/page',
    method: 'post',
    data
  })
}
// 更新车辆配置数据
export const updateMovingVehicleRecommendListApi = (data) => {
  return request({
    _showLoading: true,
    url: '/webApi/pc/moving/vehicle/car/recommend/main/update',
    method: 'post',
    data
  })
}
// 查询车辆品牌
export const getMovingVehicleBrandListApi = (data) => {
  return request({
    _showLoading: false,
    url: '/webApi/pc/moving/vehicle/car/query-brand',
    method: 'post',
    data
  })
}
// 查询车系
export const getMovingVehicleSerialListApi = (brandId) => {
  return request({
    _showLoading: false,
    url: '/webApi/pc/moving/vehicle/car/query-serial?brandId=' + brandId,
    method: 'get',
  })
}
// 查询车辆型号
export const getMovingVehicleCarListApi = (data) => {
  return request({
    _showLoading: false,
    url: '/webApi/pc/moving/vehicle/car/query-car',
    method: 'post',
    data
  })
}
